import { crc16 } from 'app/xEcoApm/helper/crc'

/**
 * Decodes a framed BLE message from a raw byte array into its payload string.
 *
 * Expected frame format: `c<payload>0x<XXXX>\r`
 * where `XXXX` is the 4-digit uppercase hex CRC-16 of the UTF-8-encoded payload.
 *
 * @param data        raw bytes received over BLE, represented as a number array.
 * @returns {string}  the decoded payload string when the CRC-16 checksum is valid.
 * @throws {Error}    if the CRC in the message does not match the computed CRC.
 * @throws {Error}    if the byte array does not conform to the expected frame format.
 */
export default (data: number[]): string => {
  const decoder = new TextDecoder();
  const message = decoder.decode(new Uint8Array(data))

  console.log('decode:message', message)

  const match = message.match(/c((?:.|\n|\r|\u2028|\u2029)*?)0x([0-9A-Fa-f]{4})\r/)

  if (match) {
    const payload = match[1]
    const crcHex = match[2]
    const crc = parseInt(crcHex, 16)
    const calculatedCrc = crc16(new TextEncoder().encode(payload))

    if (calculatedCrc === crc) {
      return payload
    }

    throw new Error(`CRC mismatch! Expected: ${calculatedCrc}; Got ${crc}`)
  }

  throw new Error('Invalid message format')
}
